import type { AdminUser } from "@features/users/api";

export type UserRole = "admin" | "user" | "viewer";

export const resolveUserRole = (user?: Pick<AdminUser, "role"> | null): UserRole => {
  const raw = String(user?.role ?? "user")
    .trim()
    .toLowerCase();

  if (raw === "admin" || raw === "user" || raw === "viewer") {
    return raw;
  }

  return "user";
};

export const isAdminUser = (user?: Pick<AdminUser, "role"> | null): boolean =>
  resolveUserRole(user) === "admin";
